<template>
  <div>
    <div style="margin: 20px 20px 0">
      <!-- 添加弹窗 -->
      <el-form
        ref="ruleForm"
        :model="formData"
        size="mini"
        class="demo-ruleForm"
        :rules="rules"
        :inline="true"
      >
        <!-- tab标题 -->
        <el-form-item label="tab标题" prop="tabsTitle">
          <el-input
            v-model="formData.tabsTitle"
            placeholder="请输入tab标题"
            size="mini"
            style="width: 200px"
          />
        </el-form-item>
        <!-- tab key值 -->
        <el-form-item label="key值" prop="key">
          <div style="display: flex">
            <el-input
              v-model="formData.key"
              placeholder="请输入key值"
              size="mini"
              style="width: 200px"
            />
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            style="margin: 0 10px"
            @click="resetForm('ruleForm')"
          >重置</el-button>
          <el-popconfirm
            title="确定新增模块？"
            @onConfirm="submitForm('ruleForm')"
          >
            <el-button
              slot="reference"
              :loading="loading"
              type="primary"
              class="edit-button"
            >新增模块</el-button>
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </div>
    <div class="warp" style="padding: 0 20px 20px">
      <el-tabs
        v-model="activeName"
        type="border-card"
        @tab-remove="removeTab"
      >
        <el-tab-pane
          v-for="item in dataList"
          :key="item.id || item.key"
          :label="item.tabsTitle"
          :name="String(item.id || item.key)"
          :closable="item.key !== 'pointcard' && item.key !== 'questionnaire'"
        >
          <div>
            <vue-ueditor-wrap
              v-model="item.values"
              :config="config"
              class="ueditor"
            />
            <div class="button">
              <el-popconfirm
                :title="`确定更新${item.tabsTitle}?`"
                @onConfirm="update(item)"
              >
                <el-button
                  slot="reference"
                  :loading="loading"
                  type="primary"
                  class="edit-button"
                >更新{{ item.tabsTitle }}</el-button>
              </el-popconfirm>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
import { list, add, edit, remove } from '@/api/globalText'
import environment from '@/utils/environment'

const DEFAULT_QUESTIONNAIRE_CONTENT = [
  '<p style="font-size:32rpx;font-weight:500;color:#333;margin:0 0 24rpx;">尊敬的用户：</p>',
  '<p style="font-size:28rpx;font-weight:400;color:#333;margin:0 0 32rpx;">感谢您抽出宝贵的时间参与我们的调查问卷，您的意见对我们至关重要。</p>',
  '<p style="font-size:28rpx;font-weight:400;color:#333;margin:0 0 32rpx;">通过您的回答，我们将更好地了解您的需求和期望，以提供更优质的服务和产品。</p>',
  '<p style="font-size:28rpx;font-weight:400;color:#333;margin:0 0 32rpx;">请您真实、详细地回答以下问题。确保我们能够充分了解您的观点和体验。</p>',
  '<p style="font-size:28rpx;font-weight:400;color:#333;margin:0 0 32rpx;">所有的回答将被严格保密，仅用于内部分析和改进之用途。</p>',
  '<p style="font-size:28rpx;font-weight:400;color:#333;margin:0 0 32rpx;">再次感谢您的参与与支持！</p>',
  '<p style="font-size:28rpx;font-weight:500;color:#333;margin:0 0 24rpx;">祝您生活愉快</p>'
].join('')

export default {
  name: 'GlobalText',
  components: { VueUeditorWrap },
  data() {
    return {
      activeName: '1', // 活动的标签栏
      register: '', // 注册协议
      ahoutUs: '', // 关于我们
      guize: '', // 隐私协议
      loading: false,
      config: {
        // UEDITOR_HOME_URL: process.env.VUE_APP_BASE_UEDITORURL, // 需要令此处的URL等于对应 ueditor.config.js 中的配置。
        // UEDITOR_HOME_URL: "/normalManager/ueditor/", // 需要令此处的URL等于对应 ueditor.config.js 中的配置。本地
        UEDITOR_HOME_URL: '/ueditor/', // 需要令此处的URL等于对应 ueditor.config.js 中的配置。服务器
        autoHeightEnabled: false,
        initialFrameHeight: 450,
        initialFrameWidth: 400,
        maximumWords: 9999999,
        // 上传文件接口
        serverUrl: '/gw/admin/operate/uploadBanner',
        headers: { Authorization: localStorage.getItem('token') },
        imageActionName: 'uploadimage',
        imageAllowFiles: ['.png', '.jpg', '.jpeg', '.gif', '.bmp'],
        imageUrlPrefix: '' /* 图片访问路径前缀 */,
        imagePathFormat: '',
        imageMaxSize: 1024 * 1000 * 10, // 单位B 10MB
        toolbars: [
          [
            'fullscreen',
            'source',
            '|',
            'undo',
            'redo',
            '|',
            'bold',
            'italic',
            'underline',
            'fontborder',
            'strikethrough',
            'removeformat',
            '|',
            'forecolor',
            'backcolor',
            'insertorderedlist',
            'insertunorderedlist',
            '|',
            'paragraph',
            'fontfamily',
            'fontsize',
            '|',
            'justifyleft',
            'justifycenter',
            'justifyright',
            'justifyjustify',
            '|',
            // "simpleupload",
            'insertimage',
            'emotion',
            '|',
            'link',
            'unlink'
          ]
        ],
        // initialFrameWidth:3000,
        zIndex: 3000,
        enableAutoSave: true // 开启从草稿箱恢复功能需要手动设置固定的 editorId，否则组件会默认随机一个，如果页面刷新，下次渲染的时候 editorId 会重新随机，导致无法加载草稿箱数据
      },
      formData: {
        tabsTitle: '',
        key: '',
        values: ''
      },
      rules: {
        tabsTitle: [
          { required: true, message: '请输入tabs标题', trigger: 'change' }
        ],
        key: [{ required: true, message: '请输入key值', trigger: 'change' }]
      },
      // 列表
      dataList: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    update(item) {
      if (this.loading) return
      this.loading = true
      const saveRequest = item.id ? edit(item) : list().then((items) => {
        // 刷新失败或其他窗口已保存时，复用已有记录，避免再次新增。
        const existing = items.find((row) => row.key === item.key)
        return existing ? edit({ ...item, id: existing.id }) : add(item)
      })
      return saveRequest
        .then(() => {
          this.$message.success('更新成功')
          return this.getList(item.key)
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 获取通用内容，集章说明在首次保存时创建。
    getList(activeKey) {
      var loading = this.$loading({
        lock: true,
        text: '加载中....',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      return list()
        .then((res) => {
          this.dataList = (res || []).map((item) => item.key === 'pointcard'
            ? { ...item, tabsTitle: '集章说明', values: item.values || '' }
            : item.key === 'questionnaire'
              ? { ...item, tabsTitle: '问卷说明', values: item.values || DEFAULT_QUESTIONNAIRE_CONTENT }
            : item)
          if (!this.dataList.some((item) => item.key === 'pointcard')) {
            this.dataList.push({ key: 'pointcard', tabsTitle: '集章说明', values: '' })
          }
          if (!this.dataList.some((item) => item.key === 'questionnaire')) {
            this.dataList.push({
              key: 'questionnaire',
              tabsTitle: '问卷说明',
              values: DEFAULT_QUESTIONNAIRE_CONTENT
            })
          }
          const activeTab = this.dataList.find((item) => activeKey
            ? item.key === activeKey
            : String(item.id || item.key) === this.activeName) || this.dataList[0]
          this.activeName = String(activeTab.id || activeTab.key)
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          loading.close()
        })
    },
    // 添加新全局参数
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.formData)
          add(this.formData).then((res) => {
            this.$message.success('添加成功')
            this.getList()
            this.resetForm('ruleForm')
          })
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    removeTab(targetName) {
      console.log(targetName)
      if (targetName) {
        this.$confirm('是否确定删除', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            remove({ ids: [Number(targetName)] }).then((res) => {
              this.$message.success('删除成功')
              this.getList()
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.button {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
}
</style>
